























import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';

import QuoteAccordionList from '@/components/Quotes/QuoteAccordionList.vue';

import Quotes, { Quote } from '@/services/Quotes';

import * as Sentry from '@sentry/browser';

@Component({
     name: 'PageQuotes',
     components: {
          Loading,
          QuoteAccordionList,
          Sidebar,
     },
})
export default class QuotesList extends Vue {
     private error: boolean;
     private loading: boolean;
     private quotes: any;

     constructor() {
          super();

          this.error = false;
          this.loading = true;
          this.quotes = [];
     }

     private async created() {
          try {
               this.quotes = await Quotes.readQuotesForUserId('');
          } catch (error) {
               Sentry.captureException(error);
               this.error = error;
          } finally {
               this.loading = false;
          }
     }
}
